$(document).on("click", ".tps-chooseCust-setting", function() {
    if($('#SingleOptionSelector-1').val() == '')
    {
      alert("PLEASE SELECT RING SIZE ");
      return false;
    }
     var setting = [{
      "product_id": $("#product_id").val(),
      "setting_id": $("#variant_id").val(),
      "product_handle": $("#product_handle").val(),
      "setting_name": $("#variant_name").val(),
      "setting_price": $("#variant_price").val(),
      "setting_metal_type": $("#variant_option1").val(),
      "setting_ring_size": $('#ringsize').val(),
      "setting_sku": $("#variant_sku").val(),
      "setting_url": $("#variant_url").val(),
      "stock_num": $("#stock_num").val(),
      "no_of_center_stone": $("#no_of_center_stone").val(),
      // "minimum_carat_total_weight": $("#minmaxcarat").val().replace('ct','').trim(),
      // "maximum_carat_total_weight": $("#minmaxcarat").val().replace('ct','').trim(),  
      "setting_type": $("#setting_type").val(),
      "meta_metal": $("#meta-metal").val(),
      "center_stone": $("#center_stone").val(),
      "image": $("#stockimg0").attr("src"),
      "setting_style": $("#setting_style").val(),
      "product_description": $("#product_description").val(),
      "side_stone_weight" : $("#side-stone-weight").val(),
      "pave_stone_weight" : $("#pave-stone-weight").val(),
      "vendor_code": $("#vendor_code").val().trim(),        
    }]; 
     localStorage.setItem("gd_ring_setting", JSON.stringify(setting));
     setSteps("gd_ring_setting");
});

/******* Choose Setting function end  ******/


/*** set currenct step and redirect to next step start ****/

function setSteps(current_step){
    window.location.href =  tps_config.urls.loose_diamond_listing+"?diamond_select=true" //"/pages/ringbuilder-loose-diamond";
}